import { EmptyState, PageLayout, Panel, SecondaryButton } from '../../components/ui';
import { useMe } from '../../lib/queries';
import { AtlasPanel, ParseErrorsPanel, ReprocessPanel } from './DataPanels';
import { DigestPanel } from './DigestPanel';
import { ResetPanel } from './ResetPanel';
import { WatcherStatusPanel } from './WatcherStatusPanel';
import { WatcherTokensPanel } from './WatcherTokensPanel';
import { WeightsPanel } from './WeightsPanel';

function AccountPanel() {
  const me = useMe();
  if (!me.data) {
    return (
      <Panel title="Account" level="side">
        <EmptyState>{me.isError ? 'Couldn’t load the account.' : 'Loading…'}</EmptyState>
      </Panel>
    );
  }
  const { user, devBypass } = me.data;
  return (
    <Panel title="Account" level="side" meta={devBypass ? 'DEV BYPASS' : 'CHESTROSE'}>
      <dl className="m-0 grid grid-cols-[max-content_minmax(0,1fr)] gap-x-3.5 gap-y-1.5 px-4 py-3 text-compact">
        <dt className="text-muted">User</dt>
        <dd className="m-0 truncate">{user.name ?? user.sub}</dd>
        {user.email && (
          <>
            <dt className="text-muted">Email</dt>
            <dd className="m-0 truncate">{user.email}</dd>
          </>
        )}
      </dl>
      {devBypass ? (
        <EmptyState>Signed in by AUTH_DEV_USER (development only).</EmptyState>
      ) : (
        <form method="post" action="/auth/logout" className="px-4 pb-4">
          <SecondaryButton type="submit">Log out</SecondaryButton>
        </form>
      )}
    </Panel>
  );
}

export function SettingsPage() {
  return (
    <PageLayout
      main={
        <>
          <WeightsPanel />
          <WatcherTokensPanel />
        </>
      }
      side={
        <>
          <WatcherStatusPanel />
          <ParseErrorsPanel />
          <AtlasPanel />
          <ResetPanel />
          <DigestPanel />
          <ReprocessPanel />
          <AccountPanel />
        </>
      }
    />
  );
}
